import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getNortonProductsAttributes,
  getNortonProductsPrice,
  getProducts,
} from '../../../store/reducers';
import {
  GetNortonProductPrice,
  GetNortonProductsAttributes,
} from '../../store/actions/norton.actions';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import { combineLatest } from 'rxjs';
import {
  CustomerService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import { CustomerAccount } from '@proximus/common-business-logic';
import { isRes, Product } from '@dch/products-business-logic';
import * as ProductsActions from '../../../store/actions/products.actions';

@Component({
  selector: 'mprd-norton360-subscription',
  templateUrl: './norton360-subscription.component.html',
  styleUrls: ['./norton360-subscription.component.css'],
})
export class Norton360SubscriptionComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  norton1Name: string;
  norton5Name: string;
  price: number;
  frequency: string;
  norton1MpcUuid: string;
  norton1Count: number;
  norton1LicenseCount: number;
  norton5MpcUuid: string;
  norton5Count: number;
  norton5LicenseCount: number;

  constructor(
    private store: Store<ApplicationState>,
    private customerService: CustomerService,
    private languageService: LanguageService,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.setNortonLicenseCount();
    this.setNortonMpcUuids();
    this.addSubscription(
      this.store.select(getNortonProductsAttributes).subscribe((value) => {
        if (value) {
          if (value[this.norton1MpcUuid]) {
            this.norton1Name =
              value[this.norton1MpcUuid].nameCms[
                this.languageService.getSelectedLanguage()
              ];
          }
          if (value[this.norton5MpcUuid]) {
            this.norton5Name =
              value[this.norton5MpcUuid].nameCms[
                this.languageService.getSelectedLanguage()
              ];
          }
        }
      }),
    );
    this.addSubscription(
      combineLatest([
        this.store.select(getNortonProductsPrice),
        this.customerService.getCustomerAccount(),
      ]).subscribe((res: [any, CustomerAccount]) => {
        const price = res[0];
        const customerAccount = res[1];
        const segment = customerAccount.getSelectedCustomer().subsegment;
        if (
          price &&
          price.calculated_prices &&
          price.calculated_prices.length > 0
        ) {
          this.frequency = price.calculated_prices[0].charge_frequency;
          this.price = isRes(segment)
            ? price.calculated_prices[0].standalone_price_vat
            : price.calculated_prices[0].standalone_price_no_vat;
        }
      }),
    );
    this.addSubscription(
      this.store.select(getProducts).subscribe((products) => {
        if (products) {
          this.norton1Count = this.countProduct(products, this.norton1MpcUuid);
          this.norton5Count = this.countProduct(products, this.norton5MpcUuid);
        }
      }),
    );
    this.store.dispatch(new ProductsActions.GetProducts());
    this.store.dispatch(
      new GetNortonProductsAttributes({
        mpcUuids: [this.norton1MpcUuid, this.norton5MpcUuid],
      }),
    );
    this.store.dispatch(
      new GetNortonProductPrice({ mpcUuid: this.norton1MpcUuid }),
    );
  }

  private countProduct(products: Array<Product>, groupMpcUuid: string) {
    return products.filter((product) => groupMpcUuid === product.groupMpcUuid)
      .length;
  }

  public setNortonLicenseCount() {
    this.norton1LicenseCount = Number(
      this.translationService.getTranslatedValueFor(
        'norton360.subscriptions.norton1LicenseCount',
      ),
    );
    this.norton5LicenseCount = Number(
      this.translationService.getTranslatedValueFor(
        'norton360.subscriptions.norton5LicenseCount',
      ),
    );
  }

  public setNortonMpcUuids() {
    this.norton1MpcUuid = this.translationService.getTranslatedValueFor(
      'norton360.subscriptions.norton1MpcUuid',
    );
    this.norton5MpcUuid = this.translationService.getTranslatedValueFor(
      'norton360.subscriptions.norton5MpcUuid',
    );
  }

  public openLink(key: string) {
    const link = this.translationService.getTranslatedValueFor(key);
    if (link) {
      window.open(link, '_blank');
    }
  }

  public getDescriptionNorton1() {
    return this.translationService
      .getTranslatedValueFor('norton360.subscriptions.norton1.description')
      .concat(
        this.translationService.getTranslatedValueFor(
          'norton360.subscriptions.norton1.description.licences',
        ),
      )
      .replace(/\{0\}/g, isNaN(this.norton1Count) ? 0 : this.norton1Count);
  }

  public getDescriptionNorton5() {
    const numberOfLicences = this.norton5Count * this.norton5LicenseCount;
    return this.translationService
      .getTranslatedValueFor('norton360.subscriptions.norton5.description')
      .concat(
        this.translationService.getTranslatedValueFor(
          'norton360.subscriptions.norton5.description.licences',
        ),
      )
      .replace(/\{0\}/g, isNaN(this.norton5Count) ? 0 : this.norton5Count)
      .replace(/\{1\}/g, isNaN(numberOfLicences) ? 0 : numberOfLicences);
  }
}
